import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import { DEFAULT_MESSAGE, TestID } from './constants';

export interface Props {
  inputWidth: number;
  message?: string;
}

const LoadingResults: React.FC<Props> = ({ inputWidth, message = DEFAULT_MESSAGE }) => (
  <div
    className="absolute bg-white rounded-md border border-gray-300 shadow-md mt-1 px-1 py-6 z-10 text-center"
    style={{
      minWidth: inputWidth || 'auto',
    }}
  >
    <p className="font-bold text-md text-gray-850">{message}</p>

    <div className="mt-4" data-testid={TestID}>
      <CircularProgress
        size={38}
        style={{
          color: '#2d80e2',
        }}
      />
    </div>
  </div>
);

export default LoadingResults;
